import { useTranslation } from "react-i18next";
import React from "react";
import { ITagDisplayProps } from "../../models/interfaces";
import { truncateText } from "src/pages/ManageStudies/transformer";
import { Tag, Tooltip } from "src/assets/imports/antdComponents";
import { safeHighlightRegExp } from "src/utils/security";

const TagDisplay: React.FC<ITagDisplayProps> = ({ tags, highlightText, maxVisibleTags = 3, truncateLength = 30, isStudyLevel = false, isChecked = false }) => {
	const { t } = useTranslation();
	const highlightedTags = (tags || []).filter((tag) => tag.label.toLowerCase().includes(highlightText.toLowerCase()));
	const remainingTags = (tags || []).filter((tag) => !tag.label.toLowerCase().includes(highlightText.toLowerCase()));
	const visibleTags = [...highlightedTags, ...remainingTags].slice(0, maxVisibleTags);
	const hiddenTags = [...highlightedTags, ...remainingTags].slice(maxVisibleTags);

	const getHighlightedText = (text: string, highlight: string) => {
		if (!highlight.trim()) return truncateText(text, truncateLength);
		const parts = text.split(safeHighlightRegExp(highlight));
		return (
			<>
				{parts.map((part, index) =>
					part.toLowerCase() === highlight.toLowerCase() ? (
						<Tag key={index} className="highlight mr-0">
							{truncateText(part, truncateLength)}
						</Tag>
					) : (
						truncateText(part, truncateLength)
					),
				)}
			</>
		);
	};

	return (
		<div className="ddn-tags mr-1">
			{visibleTags.map((tag) => (
				<Tooltip className="text-[x-small] text-[--secondary-color]" title={tag.label.length > truncateLength ? tag.label : null} key={tag.value}>
					<Tag key={tag.value} className={`ddn-tag ${isStudyLevel ? (isChecked ? "ddn-tag-selected" : "ddn-tag-unselected") : ""} mr-0`}>
						{getHighlightedText(tag.label, highlightText)}
					</Tag>
				</Tooltip>
			))}
			{hiddenTags?.length > 0 && (
				<Tooltip
					title={
						<div className="flex flex-wrap gap-1 max-w-[300px]">
							{hiddenTags.map((tag) => (
								<Tooltip className="text-[x-small] text-[--secondary-color]" title={tag.label.length > truncateLength ? tag.label : null} key={tag.value}>
									<Tag key={tag.value} className={`ddn-tag ${isStudyLevel ? (isChecked ? "ddn-tag-selected" : "ddn-tag-unselected") : ""} mr-0`}>
										{getHighlightedText(tag.label, highlightText)}
									</Tag>
								</Tooltip>
							))}
						</div>
					}
					placement={hiddenTags.length - 1 ? "topLeft" : "top"}>
					<Tag className={`ddn-tag ${isStudyLevel ? (isChecked ? "ddn-tag-selected" : "ddn-tag-unselected") : ""} cursor-pointer`}>
						+ {hiddenTags?.length} {t("more")}
					</Tag>
				</Tooltip>
			)}
		</div>
	);
};

export default TagDisplay;
